import { useEventCallback } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { ProjectCard } from '../../components/ProjectCard';
import { ProjectsList } from '../../components/ProjectsList';
import { Section } from '../../components/Section';
import { selectBuilderInfo, selectBuilderProjects } from '../../selectors/builder';
import { IProjectView } from '../../types/builder';
import { CollapsedListContainer } from '../CollapsedListContainer';
import { PROJECTS_COUNT } from './constants';
import { trackClickProjectCard, trackShowMoreProjects } from './tracking';
import { Link } from '../../components/Link';

export const ProjectsContainer = () => {
  const deviceType = useDeviceType();
  const builderInfo = useSelector(selectBuilderInfo);
  const projects = useSelector(selectBuilderProjects);

  const expandableProjectsCount = PROJECTS_COUNT[deviceType];

  const handleProjectCardClick = useEventCallback((project: IProjectView) => {
    trackClickProjectCard(builderInfo.id, `${builderInfo.name} | ${project.name} | ${project.id}`);
  });

  const handleExpandList = useEventCallback(() => {
    trackShowMoreProjects(builderInfo.id);
  });

  const renderItem = useEventCallback((project: IProjectView, index: number) => {
    return (
      <Link href={`/country-projects/${project.id}/`}>
        <ProjectCard key={index} {...project} onClick={() => handleProjectCardClick(project)} />
      </Link>
    );
  });

  const renderList = useEventCallback((children: React.ReactNode) => {
    return <ProjectsList>{children}</ProjectsList>;
  });

  if (!projects.length) {
    return null;
  }

  return (
    <Section title="Популярные проекты" dataName="Projects">
      <CollapsedListContainer
        list={projects}
        collapsedLength={expandableProjectsCount}
        expandCount={expandableProjectsCount}
        renderItem={renderItem}
        renderList={renderList}
        onExpand={handleExpandList}
      />
    </Section>
  );
};
